import EndPoint from 'Api/EndPoint';
import Client from 'Api/Client';

const endpoint = `${EndPoint.Host}/${EndPoint.Order}`;

export async function getOrderList(data) {
  return await Client.get(`${endpoint}`, data, true);
}

export async function getAllOrderList(data) {
  return await Client.get(`${endpoint}/all`, data, true);
}

export async function getOrderDetail(id) {
  return await Client.get(`${endpoint}/${id}`, {}, true);
}

export async function orderExcelExport(data, fileName) {
  return await Client.downLoadFile(`${endpoint}/excel`, data, true, fileName);
}

export async function orderCreateReady(data) {
  return await Client.post(`${endpoint}/createReady`, data, true);
}

// 주문하기 > 자재 새로고침(현장 변경시)
export async function getOrderMaterialRefresh(data) {
  return await Client.get(`${endpoint}/material/refresh`, data, true);
}

// 주문 > 결제 > 외상 결제
export async function postPaymentCreditPay(id, data) {
  return await Client.post(`${endpoint}/${id}/payment/creditPay`, data, true);
}

// 주문 > 결제 > 결제 생성
export async function postPaymentConfirm(id, data) {
  return await Client.post(`${endpoint}/${id}/payment/confirm`, data, true);
}

// 주문 > 결제 > 토스 가상계좌 생성
export async function postPaymentTossVirtualAccount(id, data) {
  return await Client.post(`${endpoint}/${id}/payment/tossCreateVirtualAccount`, data, true);
}

// 주문 > 결제 > 토스 카드결제
export async function postPaymentTossPay(id, data) {
  return await Client.post(`${endpoint}/${id}/payment/tossPay`, data, true);
}
